import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {logoutAction} from '../rootAction';

export interface SelectedClientState {
  clientBranch: any[];
  clientId: string;
  consilioClientId: string;
  name: string;
  organizationId: string;
  permissionGroup: any[];
  status: string;
  totalActiveBranches: number;
  totalActiveProjects: number;
  totalActiveWorkspaces: number;
  totalBranches: number;
  totalProjects: number;
  totalWorkspaces: number;
  type: string;
  bulkUploadClientId: string;
  hideClientDropdown?: boolean;
  skipClientSelectionModal?: boolean;
}

const initialState: SelectedClientState = {
  clientBranch: [],
  clientId: '',
  consilioClientId: '',
  bulkUploadClientId: '',
  name: '',
  organizationId: '',
  permissionGroup: [],
  status: '',
  totalActiveBranches: 0,
  totalActiveProjects: 0,
  totalActiveWorkspaces: 0,
  totalBranches: 0,
  totalProjects: 0,
  totalWorkspaces: 0,
  type: '',
  hideClientDropdown: false,
  skipClientSelectionModal: false,
};

const selectedClientSlice = createSlice({
  name: 'selectedClient',
  initialState,
  reducers: {
    setClientData(state, action: PayloadAction<SelectedClientState>) {
      return {...state, ...action.payload};
    },
    resetClientData() {
      return initialState;
    },
    updateClientStatus(state, action: PayloadAction<string>) {
      state.status = action.payload;
    },
    setBulkUploadClientId(state, action: PayloadAction<string>) {
      state.bulkUploadClientId = action.payload;
    },
    setHideClientDropdown(state, action: PayloadAction<boolean>) {
      state.hideClientDropdown = action.payload;
    },
    setSkipClientSelectionModal(state, action: PayloadAction<boolean>) {
      state.skipClientSelectionModal = action.payload;
    },
    // Add other update actions if needed
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => {
      return initialState;
    });
  },
});

export const {
  setClientData,
  setBulkUploadClientId,
  resetClientData,
  updateClientStatus,
  setHideClientDropdown,
  setSkipClientSelectionModal,
} = selectedClientSlice.actions;
export const selectedClientSliceInitialState = initialState;
export default selectedClientSlice.reducer;
